export const fonts = {
  serif: '"Fraunces", "Instrument Serif", Georgia, serif',
  sans: '"Geist", "Plus Jakarta Sans", system-ui, sans-serif',
  mono: '"Geist Mono", ui-monospace, monospace',
};

export const screen = { w: 390, h: 844 };

export const themes = {
  midnight: {
    ink: '#0e1411',
    paper: '#f6f3ec',
    mint: '#a8e6c8',
    mintDeep: '#1f6f4a',
    cream: '#ece6d6',
    muted: '#5b6660',
    hair: 'rgba(14,20,17,0.10)',
    tint: '#c9e8d5',
  },
  bone: {
    ink: '#1a1a1a',
    paper: '#efece2',
    mint: '#9ad9b9',
    mintDeep: '#1f5d3f',
    cream: '#e1dccc',
    muted: '#5a5a52',
    hair: 'rgba(0,0,0,0.10)',
    tint: '#dde9d9',
  },
  clay: {
    ink: '#1f1814',
    paper: '#efe7d8',
    mint: '#b8dcc4',
    mintDeep: '#3a6b4d',
    cream: '#e6d8be',
    muted: '#6a5a4a',
    hair: 'rgba(31,24,20,0.12)',
    tint: '#d9c8a8',
  },
};

export const defaultTheme = themes.midnight;
